import { Pagination as MuiPagination } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Pagination = styled(MuiPagination)(({ theme }) => ({
  marginTop: theme.spacing(4),

  ul: {
    justifyContent: 'center',

    'button:hover': {
      backgroundColor: theme.palette.black10.main,
    },
  },
}));
